import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { environment } from '../../../../../environments/environment';
import { ShoppingCartRequest } from '../../requests/platform/shopping-cart.request';
import { ReturnStruct } from '../../structs/return.struct';
import { GetShoppingCartResponse } from '../../responses/platform/get-shopping-cart.response';
import { AuthService } from './auth.service';
import { _isTestEnvironment } from '@angular/cdk/platform';
import { GetShoppingCartCountResponse } from '../../responses/platform/get-shopping-cart-count.response';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class ShoppingCartService extends CommonService {
  constructor(
    private httpClient: HttpClient,
    private authService: AuthService,
    @Inject(DOCUMENT) private _doc: Document,
  ) {
    super();
  }

  public getShoppingCart(zipcode: string): Observable<GetShoppingCartResponse> {
    if (this.authService.isAuthenticated()) {
      let url: string = `${environment.urlApiPlatform}ShoppingCartAuth/getShoppingCart`;
      if (zipcode) {
        url += `?zipcode=${zipcode}`;
      }
      return this.httpClient.get<GetShoppingCartResponse>(url, this.addHeaderToken())
        .pipe(catchError(this.handleError));
    }
    else {

      let url: string = `${environment.urlApiPlatform}ShoppingCart/getShoppingCart`;
      if (zipcode) {
        url += `?izipcode=${zipcode}`;
      }

      let shoppingCartRequestSession: string | null = sessionStorage.getItem("shopping-cart-request");

      if (shoppingCartRequestSession) {
        let shoppingCartRequest: ShoppingCartRequest[] = JSON.parse(shoppingCartRequestSession);

        console.log("shoppingCartRequest")
        console.log(shoppingCartRequest)
        return this.httpClient.post<GetShoppingCartResponse>(url, shoppingCartRequest)
          .pipe(catchError(this.handleError));
      }
      else {
        let emptyResponse: GetShoppingCartResponse = {
          listShoppingCart: [],
          sunTotalPriceKits: 0,
          sunTotalPriceShippingCost: 0,
          total: 0,
          isError: false,
          errorCode: 0,
          errorDescription: '',
          listPaymentMethodInstallment: []
        };
        return of(emptyResponse);
      }
    }
  }

  public addToCart(): Observable<ReturnStruct> {
    let shoppingCartRequestSession: string | null = sessionStorage.getItem("shopping-cart-request");
    if (shoppingCartRequestSession == null) {
      let returnStruct: ReturnStruct = {
        isError: false,
        errorCode: 0,
        errorDescription: ''
      };
      return of(returnStruct);
    } else {
      let shoppingCartRequest: ShoppingCartRequest[] = JSON.parse(shoppingCartRequestSession);
      sessionStorage.removeItem("shopping-cart-request");
      return this.httpClient.post<ReturnStruct>(`${environment.urlApiPlatform}ShoppingCartAuth`, shoppingCartRequest, this.addHeaderToken())
        .pipe(catchError(this.handleError));
    }
  }


  public updateQuantity(idKit: number, quantity: number): Observable<ReturnStruct> {
    if (this.authService.isAuthenticated()) {
      return this.httpClient.put<ReturnStruct>(`${environment.urlApiPlatform}ShoppingCartAuth/idKit/${idKit}/quantity/${quantity}`, null, this.addHeaderToken())
        .pipe(catchError(this.handleError));
    } else {

      let shoppingCartRequestSession: string | null = sessionStorage.getItem("shopping-cart-request");
      if (shoppingCartRequestSession == null) {
        let listShoppingCartRequest: ShoppingCartRequest[] = []
        let shoppingCartRequest: ShoppingCartRequest = new ShoppingCartRequest();
        shoppingCartRequest.idKit = idKit;
        shoppingCartRequest.quantity = quantity;
        listShoppingCartRequest.push(shoppingCartRequest);

        sessionStorage.setItem("shopping-cart-request", JSON.stringify(listShoppingCartRequest));

        let returnStruct: ReturnStruct = {
          isError: false,
          errorCode: 0,
          errorDescription: ''
        };
        return of(returnStruct);
      }

      let shoppingCartRequest: ShoppingCartRequest[] = JSON.parse(shoppingCartRequestSession);

      if (shoppingCartRequest.filter(c => c.idKit == idKit).length > 0) {
        if (quantity <= 0) {
          let shoppingCartRequestUUpdated: ShoppingCartRequest[] = shoppingCartRequest.filter(c => c.idKit != idKit);

          sessionStorage.setItem("shopping-cart-request", JSON.stringify(shoppingCartRequestUUpdated));
        } else {
          shoppingCartRequest.forEach(element => {
            if (element.idKit == idKit)
              element.quantity = quantity;
          });
          sessionStorage.setItem("shopping-cart-request", JSON.stringify(shoppingCartRequest));
        }

      } else {
        let newShoppingCartRequest: ShoppingCartRequest = new ShoppingCartRequest();
        newShoppingCartRequest.idKit = idKit;
        newShoppingCartRequest.quantity = quantity;
        shoppingCartRequest.push(newShoppingCartRequest);
        sessionStorage.setItem("shopping-cart-request", JSON.stringify(shoppingCartRequest));
      }

      let returnStruct: ReturnStruct = {
        isError: false,
        errorCode: 0,
        errorDescription: ''
      };
      return of(returnStruct);
    }
  }



  public getCount(): Observable<GetShoppingCartCountResponse> {

    if (this.authService.isAuthenticated()) {
      return this.httpClient.get<GetShoppingCartCountResponse>(`${environment.urlApiPlatform}ShoppingCartAuth/count`, this.addHeaderToken())
        .pipe(catchError(this.handleError));
    } else {
      let shoppingCartRequestSession: string | null = sessionStorage.getItem("shopping-cart-request");
      let count: number = 0;
      if (shoppingCartRequestSession != null) {
        let shoppingCartRequest: ShoppingCartRequest[] = JSON.parse(shoppingCartRequestSession);
        shoppingCartRequest.forEach(element => {
          count = count + element.quantity
        });
      }
      let getShoppingCartCountResponse: GetShoppingCartCountResponse = {
        isError: false,
        errorCode: 0,
        errorDescription: '',
        count: count
      };
      return of(getShoppingCartCountResponse);
    }
  }
}
